// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2eURE","author":"Table_author__1Tl64","authorImage":"Table_authorImage__gGyVQ","unreadRow":"Table_unreadRow___ep42"};